export default __webpack_public_path__ + "static/media/group.f655dbe2.svg";